// frontend/src/lib/leveling.js
// Mirrors backend/utils/leveling.py constants. Used for display-only calculation
// (the backend is authoritative for actual award decisions).

export const TIER_RANGES = [
  { min: 1, max: 4, name: "rookie" },
  { min: 5, max: 14, name: "bronze" },
  { min: 15, max: 29, name: "silver" },
  { min: 30, max: 49, name: "gold" },
  { min: 50, max: 79, name: "platinum" },
  { min: 80, max: 99, name: "diamond" },
  { min: 100, max: Infinity, name: "legend" },
];

export const TIER_DISPLAY = {
  rookie: {
    label: "Rookie",
    color: "#9ca3af",        // gray
    ringClass: "",            // no ring
    glow: "",
  },
  bronze: {
    label: "Bronze",
    color: "#a16539",
    ringClass: "ring-2 ring-[#a16539]",
    glow: "shadow-[0_0_8px_rgba(161,101,57,0.4)]",
  },
  silver: {
    label: "Silver",
    color: "#c0c0c0",
    ringClass: "ring-2 ring-[#c0c0c0]",
    glow: "shadow-[0_0_8px_rgba(192,192,192,0.4)]",
  },
  gold: {
    label: "Gold",
    color: "#facc15",
    ringClass: "ring-2 ring-yellow-400",
    glow: "shadow-[0_0_10px_rgba(250,204,21,0.5)]",
  },
  platinum: {
    label: "Platinum",
    color: "#22d3ee",
    ringClass: "ring-2 ring-cyan-400",
    glow: "shadow-[0_0_10px_rgba(34,211,238,0.5)]",
  },
  diamond: {
    label: "Diamond",
    color: "#a78bfa",
    ringClass: "ring-[3px] ring-violet-400 ring-offset-1 ring-offset-transparent",
    glow: "shadow-[0_0_14px_rgba(167,139,250,0.6)]",
  },
  legend: {
    label: "Legend",
    color: "#fb923c",  // brand orange
    ringClass: "ring-[3px] ring-orange-500",
    glow: "shadow-[0_0_18px_rgba(251,146,60,0.7)]",
    animated: true,
  },
};

export function tierForLevel(level) {
  for (const t of TIER_RANGES) {
    if (level >= t.min && level <= t.max) return t.name;
  }
  return "rookie";
}

export function tierDisplay(tierOrLevel) {
  const tier = typeof tierOrLevel === "number"
    ? tierForLevel(tierOrLevel)
    : tierOrLevel;
  return TIER_DISPLAY[tier] || TIER_DISPLAY.rookie;
}

// Activity → label for breakdown sheet
export const ACTIVITY_LABELS = {
  workout: "Workout",
  diet: "Diet logged",
  streak: "Streak",
  checkin: "Check-in",
  measurement: "Measurement",
  fasting: "Fasting",
  supplement_adherence: "Supplements",
  social_post: "Social post",
  pr: "Personal record",
  goal_completed: "Goal completed",
};
